import { render, staticRenderFns } from "./PurchaseDetailBox.vue.html?vue&type=template&id=14464690&scoped=true&"
import script from "./PurchaseDetailBox.component.js?vue&type=script&lang=vueJs&"
export * from "./PurchaseDetailBox.component.js?vue&type=script&lang=vueJs&"
import style0 from "./PurchaseDetailBox.scss?vue&type=style&index=0&id=14464690&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14464690",
  null
  
)

export default component.exports